import media from "../styles/media";

const theme = {
  color: {},
  ...media,
};

export default theme;
